module.exports = __webpack_public_path__ + "img/icon_h-drag-store.1eaeb6a4.png";